import React from "react";
import { SanitizedHtml } from "wup-module1-base";

const ModalText = (data) => {
  let icon = { backgroundImage: `url(${data.icon})` };

  return (
    <>
      <div className="text-box text-height">
        <div className="description-box-modal">
          <div className="offer-header">
            <div className="choose-icon-modal" style={icon}></div>
            <div className="title-modal">{data.title}</div>
          </div>
          <div className="description-2-modal">
            {data.isJSON ? (
              <SanitizedHtml html={data.description[data.current]} />
            ) : (
              <SanitizedHtml html={data.description} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalText;
